/**
 * A conversa guardada (`W-15`, ADR-050) como a tela a mostra: cada pergunta com a resposta
 * que veio depois. Serve ao painel de quem pergunta e à leitura do administrador.
 */
import type { ConversaInteira, RespostaDoAgente } from "../api/tipos";

export interface Turno {
  pergunta: string;
  resposta?: RespostaDoAgente;
  erro?: string;
}

export function turnosDaConversa(conversa: ConversaInteira): Turno[] {
  const turnos: Turno[] = [];
  for (const m of conversa.mensagens) {
    if (m.papel === "usuario") {
      turnos.push({
        pergunta: m.pergunta ?? "",
        erro: "Esta pergunta ficou sem resposta registrada.",
      });
    } else if (m.resposta && turnos.length > 0) {
      const ultimo = turnos[turnos.length - 1]!;
      turnos[turnos.length - 1] = {
        pergunta: ultimo.pergunta,
        resposta: m.resposta,
      };
    }
  }
  return turnos;
}
